import { useRef } from 'react';
import './SpotlightCard.css';

const SpotlightCard = ({ 
  children, 
  className = '', 
  spotlightColor = 'rgba(99, 102, 241, 0.3)',
  as = 'div',
  ...props 
}) => {
  const divRef = useRef(null);

  const handleMouseMove = e => {
    if (!divRef.current) return;
    const rect = divRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    divRef.current.style.setProperty('--mouse-x', `${x}px`);
    divRef.current.style.setProperty('--mouse-y', `${y}px`);
    divRef.current.style.setProperty('--spotlight-color', spotlightColor);
  };

  const Component = as;

  return (
    <Component 
      ref={divRef} 
      onMouseMove={handleMouseMove} 
      className={`card-spotlight ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
};

export default SpotlightCard;
